import logo from './logo.svg';
import './App.css';
import Header from './components/Header'
import Project from './components/Project'
import About from './components/About'
import Contact from './components/Contact'
import Footer from './components/Footer';
import Skills from './components/Skills';

function App() {

  const projects = [
    {
      title: 'LeagueBoosts',
      description: 'The Elo Boosting Services platform. Customers place an order then pay and Boosters take their assigned order. (In progress)',
      imageUrl: 'https://via.placeholder.com/150',
      demoUrl: '',
      githubUrl: '',
      shortTitle: 'That project is not OSS',
      technologies: ['React.js', 'ASP.NET API 6.0', 'SPA Proxy', 'JWT', 'Google & Discord OAuth2', 'MSSQL', 'PayPal Payments']
    },
    {
      title: 'ChatVerse',
      description: 'Realtime chatting app made in .NET 7 including: Minimal Web API, JWT Auth, GraphQL (HotChocolate), Postgres, YARP Reverse Proxy',
      imageUrl: 'https://via.placeholder.com/150',
      demoUrl: 'https://github.com/Lukeuke/ChatVerse',
      githubUrl: 'https://github.com/Lukeuke/ChatVerse',
      shortTitle: 'View the Project',
      technologies: ['.NET 7 Minimal Web API', 'Blazor', 'JWT Auth', 'GraphQL (HotChocolate)', 'Postgres', 'YARP', 'BlazoredLocalStorage']
    },
    {
      title: 'TurniejKornik',
      description: 'Managing application with Admin Panel. Made for organizing League of Legends tournaments at school, allowing to creating, managing teams.',
      imageUrl: 'https://cdn.discordapp.com/attachments/753722496141885521/1205980928392822814/image.png?ex=65da5843&is=65c7e343&hm=e6a25a0e885a50a291f3685f42b75cacfb8b136c2e72e07b358ac386b3f657dd&',
      demoUrl: '',
      githubUrl: 'https://github.com/BigBrain-Solutions/TurniejKornik',
      shortTitle: 'No demo aviable',
      technologies: ['ASP.NET MVC 7', 'Postgres', 'Cookie based Authentication']
    },
  ];

  return (
    <div className="App">
        <Header/>
        <main>
          <About id="about" />

          <div className="container mx-auto py-8" id="projects">
            <h1 className="text-3xl font-bold mb-4">Projects</h1>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {projects.map((project, index) => (
                <Project key={index} {...project} />
              ))}
            </div>
          </div>

            <Skills />
            <Contact />
        </main>
        <Footer />
      </div>
    );
}

export default App;
